module.exports = __webpack_public_path__ + "static/media/IBM.49dce5ff.jpg";